import { Location, NgClass } from '@angular/common';
import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import {
    CookieService,
    DeviceService,
    LoginNavigationService,
    MediaQueryService,
    MessageQueueService,
    NativeAppService,
    NavigationService,
    TrackingService,
    UserService,
    ViewTemplateForClient,
} from '@frontend/vanilla/core';
import { CrossProductLayoutComponent } from '@frontend/vanilla/features/cross-product-layout';
import { LhHeaderBarComponent } from '@frontend/vanilla/features/header-bar';
import { MessagePanelComponent } from '@frontend/vanilla/features/message-panel';
import {
    DateComponent,
    DateRangeValidatorDirective,
    FormFieldComponent,
    ValidationConfig,
    ValidationMessagesComponent,
} from '@frontend/vanilla/shared/forms';
import { KycStatusService } from '@frontend/vanilla/shared/kyc';
import { WorkflowService } from '@frontend/vanilla/shared/login';

import { CommonClientConfig } from '../../client-config/client-config.models';
import { UploadFileComponent } from '../../doc-upload/upload-file.component';
import { PORTAL_FORMS_COMPONENTS } from '../../forms/forms-component';
import { ValidationCheckResponse } from '../../modular-forms/models/resource-models';
import { NewAccountMenuService } from '../../services/account-menu-v2.service';
import { ContactResourceService } from '../contact-resource.service';
import { DocStatusType, DocumentSelected, HelpPageContactData, WebAnalyticsModel } from '../contact.models';

@Component({
    selector: 'pt-email-option',
    templateUrl: 'email-option.component.html',
    imports: [
        CrossProductLayoutComponent,
        LhHeaderBarComponent,
        MessagePanelComponent,
        FormsModule,
        FormFieldComponent,
        ValidationMessagesComponent,
        NgClass,
        DateComponent,
        DateRangeValidatorDirective,
        ...PORTAL_FORMS_COMPONENTS,
        UploadFileComponent,
    ],
})
export class EmailOptionComponent implements OnInit, OnDestroy, AfterViewChecked {
    content: ViewTemplateForClient;
    showEmailScreen: boolean;
    initData: any;
    preSelectedCategory: any;
    preSelectedCategoryPhase3: any;
    emailAutoFill: any;
    length: number;
    data: HelpPageContactData;
    helpAndContactPageData: HelpPageContactData;
    contactPageVisible: boolean = true;
    isShown: boolean = false;
    emailAvailable: boolean = true;
    updateEmailButton: boolean = false;
    updateEmailBody: string;
    wait: boolean = false;
    emailScreenTitle: any;
    complaintScreenTitle: string;
    pageTitle: any;
    showBanner: boolean;
    showBackButton: boolean;
    loggedInTracking: string = '';
    currentPage: string = '';
    emailAction: string = '';
    screenHeight: any;
    messagePlaceHolder: string;
    validationRuleMinlength: any;
    complaintFormCategoriesList: any = [];
    greeceEmailText: string = '';
    greeceUploadTitle: string = '';
    isGreeceComplaintEnabled: boolean = false; //toggle official complaint form ON/OFF DYNACON+queryParam
    kycStatus: any = null;
    enableBackIdUpload: boolean = true;
    isMobile: boolean;
    uploadedDocumentHasErrors = false;
    redirectedFromSASWFlow: boolean = false;
    @ViewChild('helpandcontactForm') currentForm: NgForm;
    @ViewChild('dateofbirth') dateofbirth: ElementRef;
    @Input() contactData: any;
    @Input() isNewDobEnabled: boolean = false;
    @Input() enableDragAndDrop: boolean = true;
    @Output() disableEmailScreen: EventEmitter<boolean> = new EventEmitter();
    constructor(
        private user: UserService,
        private loginNavigationService: LoginNavigationService,
        public validation: ValidationConfig,
        private contactResourceService: ContactResourceService,
        public commonClientConfig: CommonClientConfig,
        private messageQueue: MessageQueueService,
        private navigation: NavigationService,
        private tracking: TrackingService,
        private location: Location,
        private workflowService: WorkflowService,
        private nativeAppService: NativeAppService,
        private cookieService: CookieService,
        private activatedRoute: ActivatedRoute,
        private kycStatusService: KycStatusService,
        private ref: ChangeDetectorRef,
        public newAccountMenuService: NewAccountMenuService,
        private device: DeviceService,
        public mediaQueryService: MediaQueryService,
    ) {
        this.helpAndContactPageData = new HelpPageContactData();
    }

    ngOnInit() {
        document.getElementsByTagName('html')[0].classList.add('remove-bgColor');
        this.redirectedFromSASWFlow =
            this.navigation.location.search.has('source') && this.navigation.location.search.get('source') == 'sasw' ? true : false;
        this.showBackButton = true;
        if (this.navigation.location.search.get('email') == 'true') {
            this.showBackButton = false;
        }
        this.showBanner = true;
        this.messageQueue.clear();
        this.newAccountMenuService.scrollToTop();
        this.data = this.helpAndContactPageData;
        this.initData = this.contactData;
        this.isGreeceComplaintEnabled =
            this.navigation.location.search.get('source') &&
            this.navigation.location.search.get('source') == 'complaintform' &&
            this.initData.contactData.enableGreeceComplaintForm
                ? true
                : false; //QueryParam+Dynacon
        this.loggedInTracking = this.user.isAuthenticated ? WebAnalyticsModel.loggedIn : WebAnalyticsModel.notLoggedIn;
        if (this.user && !this.user.isAuthenticated && this.user.workflowType === 0) {
            this.isShown = true;
        }
        if (this.user.isAuthenticated) {
            this.emailAutoFill = this.user.email;
            this.data.email = this.user.email;

            if (this.isGreeceComplaintEnabled) {
                this.data.firstName = this.user.firstName || '';
                this.data.surname = this.user.lastName || '';
                this.data.birthData = this.user.dateOfBirth || null;
                this.data.permanentAddress = this.user.claims.get('streetaddress') || '';
            }
            this.currentPage = this.initData.contactData.isVipUser ? WebAnalyticsModel.vip : WebAnalyticsModel.nonVip;
        }
        this.capturePageLoadTracking(`Help_Contact_ContactOptions_Email_${this.loggedInTracking}${this.currentPage}_SendUsAnEmail`);
        if (!this.user.isAuthenticated) {
            this.captureEventTracking('Help_Contact_ContactOptions_Email_NotLoggedIn_Email_Clicked');
        } else {
            if (this.initData.contactData.isVipUser) {
                this.captureEventTracking('Help_Contact_ContactOptions_Email_LoggedIn_VIP_Email_Clicked');
            } else {
                this.captureEventTracking('Help_Contact_ContactOptions_Email_LoggedIn_nonVIP_Email_Clicked');
            }
        }
        this.emailScreenTitle = this.initData.contactData.helpContactContent.messages.EmailScreenTitle;
        this.complaintScreenTitle = this.initData.contactData.helpContactContent.messages.ComplaintScreenTitle;
        this.messagePlaceHolder = this.initData.contactData.helpContactContent.form.message.toolTip.replace(
            '{0}',
            this.validation.rules.messageBox.minLength,
        );
        this.preSelectedCategory = this.initData.selectedCategory;
        this.preSelectedCategory =
            this.preSelectedCategory && this.initData.contactData.enableHelpAndContactPhase3
                ? this.initData.contactData.newCategoriesList.filter((x: any) => x.category.parent.title === this.preSelectedCategory.parent.title)[0]
                      .category
                : this.initData.selectedCategory;
        this.kycStatusService.kycStatus.subscribe((result) => {
            this.kycStatus = result;
        });
        if (this.activatedRoute.snapshot.queryParamMap.get('showContact') == 'true' && this.activatedRoute.snapshot.queryParamMap.get('keyword')) {
            let _categoriesList: any;
            _categoriesList = this.initData.contactData.useNewHelpAndContactTemplate
                ? this.initData.contactData.newCategoriesList.filter((x: any) => x.id.toLowerCase() == 'other'.toLowerCase())[0]
                : this.initData.contactData.oldCategoriesList.filter((x: any) => x.id.toLowerCase() == 'other'.toLowerCase())[0];
            if (_categoriesList == undefined || _categoriesList?.length == 0) {
                const otherOption = { id: 'other', category: {} };
                if (this.initData.contactData.useNewHelpAndContactTemplate) {
                    otherOption.category = { parent: { title: this.initData.contactData.helpContactContent.messages.ShowContactDefaultSubject } };
                    this.initData.contactData.newCategoriesList.push(otherOption);
                } else {
                    otherOption.category = { title: this.initData.contactData.helpContactContent.messages.ShowContactDefaultSubject };
                    this.initData.contactData.oldCategoriesList.push(otherOption);
                }
                _categoriesList = otherOption;
            }
            this.preSelectedCategory = _categoriesList.category;
        }
        this.pageTitle = '';
        this.validationRuleMinlength = this.validation.rules.messageBox.minLength;
        this.setFooter();
        if (this.isGreeceComplaintEnabled) {
            this.greeceEmailText = this.initData.contactData.clientContentData.form.emailaddress.values.find(
                (e: any) => e.value == 'GreeceEmailText',
            ).text;
            this.greeceUploadTitle = this.initData.contactData.clientContentData.form.message.values.find(
                (e: any) => e.value == 'GreecePlaceholder',
            ).text;
            this.prepareCategoryList();
        }
        this.isMobile = this.device.isMobile || this.nativeAppService.isNativeWrapper;
    }

    ngAfterViewChecked() {
        this.ref.detectChanges();
    }

    prepareCategoryList() {
        const otherCategory = this.initData.contactData.newCategoriesList.find((e: any) => e.id === 'other');
        const complaintFormTitle = otherCategory.category.childs[3].faqTitle; // should always be 4th template in folder
        this.preSelectedCategory = complaintFormTitle;
        this.complaintFormCategoriesList.push(complaintFormTitle);
    }

    checkIncidentDateError() {
        const incidentFieldControl = <UntypedFormControl>this.currentForm.controls.dateofincident;

        if (this.data.dateofincident != null && this.data.dateofincident.getFullYear().toString().length === 4) {
            const currentTime: any = this.resetTime(new Date());
            const incidentTime: any = this.resetTime(this.data.dateofincident);

            if (incidentTime > currentTime)
                //incident date is greater than current date
                incidentFieldControl.setErrors({ olderThan: true });
            else if (incidentFieldControl.errors) delete incidentFieldControl.errors['olderThan'];

            const diff = currentTime - incidentTime;

            if (diff / (1000 * 60 * 60) / 24 > this.initData.contactData.greeceMinimumIncidentDays)
                incidentFieldControl.setErrors({ timeExpired: true });
            else if (incidentFieldControl.errors) delete incidentFieldControl.errors['timeExpired'];
        }
    }

    resetTime(date: Date) {
        return date.setHours(0, 0, 0, 0);
    }

    sendMail() {
        this.captureEventTracking(`Help_Contact_ContactOptions_Email_${this.loggedInTracking}${this.currentPage}_Submit_Clicked`);

        this.emailScreenTitle = this.initData.contactData.helpContactContent.title;
        this.complaintScreenTitle = this.initData.contactData.helpContactContent.title;
        let dataToSend: any = {};
        let enableUpdateEmail = false;

        if (!this.isGreeceComplaintEnabled) {
            if (this.initData.contactData.enableHelpAndContactPhase2)
                this.data.category = this.preSelectedCategory !== null ? this.preSelectedCategory.parent.title : '';
            else this.data.category = this.preSelectedCategory !== null ? this.preSelectedCategory.title : '';
        } else this.data.category = this.preSelectedCategory != null ? this.preSelectedCategory : '';
        this.data.isCPCCUser = this.initData.isCPCCUser;
        dataToSend = this.data;
        dataToSend.isGreeceComplaintEnabled = this.isGreeceComplaintEnabled;
        this.updateEmailBody = this.initData.contactData.helpContactContent.messages.UpdateEmailBody.replace('{0}', this.emailAutoFill).replace(
            '{1}',
            this.data.email,
        );

        if (this.isFormValid()) {
            if (this.user.isAuthenticated) {
                if (this.data.email !== this.emailAutoFill) {
                    if (this.emailAvailable) {
                        enableUpdateEmail = true;
                        this.currentPage = '_EmailChanged_NotDuplicate';
                    } else {
                        this.currentPage = '_EmailChanged_Duplicate';
                    }
                } else {
                    this.currentPage = '_EmailNotChanged';
                }
                this.capturePageLoadTracking(`Help_Contact_ContactOptions_Email_LoggedIn${this.currentPage}`);
            }

            if (
                this.activatedRoute.snapshot.queryParamMap.get('showContact') == 'true' &&
                this.activatedRoute.snapshot.queryParamMap.get('keyword')
            ) {
                dataToSend.category = dataToSend.category + '$Keyword_' + this.activatedRoute.snapshot.queryParamMap.get('keyword');
            } else if (this.kycStatus && !this.kycStatus?.kycVerified && dataToSend.document?.Data?.length > 0) {
                const subjectID = this.initData.contactData.useNewHelpAndContactTemplate
                    ? this.initData.contactData.newCategoriesList.filter((x: any) => x.category.parent.title == this.data.category)[0]?.id
                    : this.initData.contactData.oldCategoriesList.filter((x: any) => x.category.title == this.data.category)[0]?.id;
                dataToSend.category =
                    this.initData.contactData.subjects.filter((x: any) => x.toLowerCase() == subjectID?.toLowerCase()).length > 0
                        ? dataToSend.category + '$Riskroute_true'
                        : dataToSend.category;
            }
            if (this.initData.contactData.enableMultiDocUpload) {
                if (this.enableBackIdUpload) {
                    dataToSend.document = this.data.document;
                    dataToSend.backDocument = this.data.backDocument;
                    this.tracking.triggerEvent('Event.Tracking', {
                        'component.CategoryEvent': 'help center',
                        'component.LabelEvent': 'help options',
                        'component.ActionEvent': 'click',
                        'component.PositionEvent': 'official complaint form',
                        'component.LocationEvent': 'id',
                        'component.EventDetails': 'submit',
                        'component.URLClicked': 'not applicable',
                    });
                } else {
                    dataToSend.document = this.data.passportDocument;
                    dataToSend.backDocument = null;
                    this.tracking.triggerEvent('Event.Tracking', {
                        'component.CategoryEvent': 'help center',
                        'component.LabelEvent': 'help options',
                        'component.ActionEvent': 'click',
                        'component.PositionEvent': 'official complaint form',
                        'component.LocationEvent': 'passport',
                        'component.EventDetails': 'submit',
                        'component.URLClicked': 'not applicable',
                    });
                }
            } else {
                if (this.isGreeceComplaintEnabled)
                    this.tracking.triggerEvent('Event.Tracking', {
                        'component.CategoryEvent': 'Help Center',
                        'component.LabelEvent': 'Help options',
                        'component.ActionEvent': 'Click',
                        'component.PositionEvent': 'Official Complaint Form',
                        'component.LocationEvent': 'not applicable',
                        'component.EventDetails': 'Submit',
                        'component.URLClicked': 'not applicable',
                    });
            }
            this.contactResourceService.postHelpAndContactData(dataToSend).subscribe(
                () => {
                    this.newAccountMenuService.scrollToTop();
                    let trackingPage = this.location.path();
                    if (dataToSend.category !== null) {
                        trackingPage += '/' + dataToSend.category;
                    }
                    this.tracking.triggerEvent('Event.ContactPage', { 'page.siteSection': 'ContactMailSend', 'page.name': trackingPage });
                    this.contactPageVisible = false;

                    if (this.isGreeceComplaintEnabled)
                        this.tracking.triggerEvent('Event.Tracking', {
                            'component.CategoryEvent': 'Help Center',
                            'component.LabelEvent': 'Help options',
                            'component.ActionEvent': 'Load',
                            'component.PositionEvent': 'Official Complaint Form',
                            'component.LocationEvent': 'not applicable',
                            'component.EventDetails': 'Confirmation Screen',
                            'component.URLClicked': 'not applicable',
                        });

                    this.showBanner = false;
                    this.showBackButton = false;
                    if (enableUpdateEmail) {
                        this.updateEmailButton = true;
                    }
                    this.contactPageVisible = false;
                    if (enableUpdateEmail) {
                        this.updateEmailButton = true;
                    }
                },
                () => {},
            );
        } else {
            const isVipTracking = this.user.isAuthenticated
                ? this.initData.contactData.isVipUser
                    ? WebAnalyticsModel.vip
                    : WebAnalyticsModel.nonVip
                : '';
            this.captureEventTracking(`Help_Contact_ContactOptions_Email_${this.loggedInTracking}${isVipTracking}_FieldValidation_Error`);
        }
    }

    getEmailAddress(message: string) {
        this.data.email = message;
    }

    isFormValid(): boolean {
        let isInvalidForm: boolean = false;
        const controls = this.currentForm.controls;
        if (!this.currentForm.valid) {
            if (controls.firstname !== undefined && this.isNullOrEmpty(controls.firstname.value)) {
                controls.firstname.markAsTouched();
            }
            if (controls.lastname !== undefined && this.isNullOrEmpty(controls.lastname.value)) {
                controls.lastname.markAsTouched();
            }
            if (controls.emailaddress !== undefined && this.isNullOrEmpty(controls.emailaddress.value)) {
                controls.emailaddress.markAsTouched();
            }
            if (controls.dateofbirth !== undefined && this.isNullOrEmpty(controls.dateofbirth.value)) {
                controls.dateofbirth.markAsTouched();
            }
            if (controls.messagebox !== undefined && this.isNullOrEmpty(controls.messagebox.value)) {
                controls.messagebox.markAsTouched();
            }
            if (controls.category !== undefined && this.isNullOrEmpty(controls.category.value)) {
                controls.category.markAsTouched();
            }
            isInvalidForm = true;
        }
        if (this.currentForm.untouched) {
            isInvalidForm = true;
        }
        return isInvalidForm ? false : true;
    }

    isNullOrEmpty(field: string): boolean {
        if (field !== undefined && field !== null && field.length > 0) return false;
        return true;
    }

    checkDuplicateEmail() {
        if (this.data.email && this.user.isAuthenticated) {
            this.contactResourceService.checkEmail(this.data.email).subscribe(
                (data: ValidationCheckResponse) => {
                    if (!data.hasSucceeded && data.errorType === 'EmailAddress_Duplicate_Email_Violation') {
                        this.emailAvailable = false;
                    } else {
                        this.emailAvailable = true;
                    }
                },
                () => {},
            );
        }
    }
    triggerEmailVerification() {
        this.contactResourceService.triggerEmailVerification().subscribe(
            () => {},
            () => {},
        );
    }
    updateEmail() {
        this.captureEventTracking(`Help_Contact_ContactOptions_Email_LoggedIn${this.currentPage}_Yes_Clicked`);
        const emailVerificationEnabled = this.initData.contactData.emailVerificationEnabled;
        this.contactResourceService.updateEmail(this.data.email).subscribe(
            () => {
                this.updateEmailButton = false;
                if (emailVerificationEnabled) {
                    this.triggerEmailVerification();
                    this.captureEventTracking(`Help_Contact_ContactOptions_Email_LoggedIn${this.currentPage}_VerificationFlow_Triggered`);
                }
                this.currentPage = '_EmailChanged_NotDuplicate_EmailUpdate';
                this.captureEventTracking(`Help_Contact_ContactOptions_Email_LoggedIn${this.currentPage}_Message`);
            },
            () => {},
        );
    }
    frontIdSelected(selectedDoc: DocumentSelected) {
        if (selectedDoc.status === DocStatusType.docLoaded || selectedDoc.status === DocStatusType.docCleared) {
            this.data.document = selectedDoc.data;
            this.uploadedDocumentHasErrors = false;
        }
        if (selectedDoc.status === DocStatusType.docError || selectedDoc.status === DocStatusType.docSizeError) {
            this.data.document = null;
        }
        if (this.initData.contactData.enableMultiDocUpload) {
            this.handleSelectedMultiDocChange(selectedDoc, 'Id doc', 'front');
        } else {
            this.handleSelectedDocChange(selectedDoc);
        }
    }
    backIdSelected(selectedDoc: DocumentSelected) {
        if (selectedDoc.status === DocStatusType.docLoaded || selectedDoc.status === DocStatusType.docCleared) {
            this.data.backDocument = selectedDoc.data;
        }
        if (selectedDoc.status === DocStatusType.docError || selectedDoc.status === DocStatusType.docSizeError) {
            this.data.backDocument = null;
        }
        if (this.initData.contactData.enableMultiDocUpload) {
            this.handleSelectedMultiDocChange(selectedDoc, 'Id doc', 'back');
        } else {
            this.handleSelectedDocChange(selectedDoc);
        }
    }
    passportSelected(selectedDoc: DocumentSelected) {
        if (selectedDoc.status === DocStatusType.docLoaded || selectedDoc.status === DocStatusType.docCleared) {
            this.data.passportDocument = selectedDoc.data;
        }
        if (selectedDoc.status === DocStatusType.docError || selectedDoc.status === DocStatusType.docSizeError) {
            this.data.passportDocument = null;
        }
        this.handleSelectedMultiDocChange(selectedDoc, 'passport', 'front');
    }
    frontIdSupportDocSelected(selectedDoc: DocumentSelected) {
        if (selectedDoc.status === DocStatusType.docLoaded || selectedDoc.status === DocStatusType.docCleared) {
            this.data.supportDocument = selectedDoc.data;
        }
        if (selectedDoc.status === DocStatusType.docError || selectedDoc.status === DocStatusType.docSizeError) {
            this.data.supportDocument = null;
        }
        this.wait = true;
        this.handleSelectedSupportDocChange(selectedDoc);
    }
    gotoContactOptionScreen() {
        this.captureEventTracking(`Help_Contact_ContactOptions_Email_${this.loggedInTracking}${this.currentPage}_Back_Clicked`);
        this.initData.optionsScreen = true;
        this.disableEmailScreen.emit(true);
        this.initData.helpAndContactData.showEmailScreen = false;
        this.initData.helpAndContactData.showButtons = false;
        this.messageQueue.clear();
    }

    gotoLastKnownProduct(clickAction: string = '') {
        this.captureEventTracking(`Help_Contact_ContactOptions_Email_${this.loggedInTracking}${this.currentPage}_${clickAction}_Clicked`);
        if (this.activatedRoute.snapshot.queryParamMap.get('showContact') == 'true' && this.activatedRoute.snapshot.queryParamMap.get('keyword')) {
            this.gotoContactOptionScreen();
        } else {
            if (this.isGreeceComplaintEnabled && clickAction == 'Close') {
                if (this.contactPageVisible)
                    this.tracking.triggerEvent('Event.Tracking', {
                        'component.CategoryEvent': 'Help Center',
                        'component.LabelEvent': 'Help options',
                        'component.ActionEvent': 'Click',
                        'component.PositionEvent': 'Official Complaint Form',
                        'component.LocationEvent': 'not applicable',
                        'component.EventDetails': 'Close',
                        'component.URLClicked': 'not applicable',
                    });
                else
                    this.tracking.triggerEvent('Event.Tracking', {
                        'component.CategoryEvent': 'Help Center',
                        'component.LabelEvent': 'Help options',
                        'component.ActionEvent': 'Click',
                        'component.PositionEvent': 'Official Complaint Form',
                        'component.LocationEvent': 'Confirmation Screen',
                        'component.EventDetails': 'Close',
                        'component.URLClicked': 'not applicable',
                    });
            }

            if (this.isGreeceComplaintEnabled && clickAction == 'Back') {
                if (this.contactPageVisible)
                    this.tracking.triggerEvent('Event.Tracking', {
                        'component.CategoryEvent': 'Help Center',
                        'component.LabelEvent': 'Help options',
                        'component.ActionEvent': 'Click',
                        'component.PositionEvent': 'Official Complaint Form',
                        'component.LocationEvent': 'not applicable',
                        'component.EventDetails': 'Back',
                        'component.URLClicked': 'not applicable',
                    });
                else
                    this.tracking.triggerEvent('Event.Tracking', {
                        'component.CategoryEvent': 'Help Center',
                        'component.LabelEvent': 'Help options',
                        'component.ActionEvent': 'Click',
                        'component.PositionEvent': 'Official Complaint Form',
                        'component.LocationEvent': 'Confirmation Screen',
                        'component.EventDetails': 'Back',
                        'component.URLClicked': 'not applicable',
                    });

                this.navigation.goTo('');
            } else if (
                this.navigation.location.search.has('source') &&
                (this.navigation.location.search.get('source') === 'documentupload' ||
                    (this.navigation.location.search.get('source') === 'mohinterceptor' && !this.nativeAppService.isNativeApp))
            ) {
                this.navigation.goToLastKnownProduct({ forceHistoryBack: false });
            } else if (this.nativeAppService.isNativeApp) {
                if (this.cookieService.get('lastKnownProduct')) {
                    const lastKnownProduct: any = this.cookieService.get('lastKnownProduct');
                    if (lastKnownProduct && lastKnownProduct.includes('thegrid')) {
                        this.navigation.goToLastKnownProduct();
                    }
                }
                this.loginNavigationService.goToHome();
            } else {
                if (this.user.workflowType === 43) {
                    const requestParams: any = [];
                    requestParams.push({ key: 'newEmail', value: 'SKIP' });
                    this.workflowService.finalizeWithData(requestParams).then(
                        () => {
                            if (this.user.workflowType == 0) this.loginNavigationService.goToHome();
                        },
                        () => {},
                    );
                } else this.navigation.goToLastKnownProduct({ forceHistoryBack: true });
            }
        }
    }

    gotoHome() {
        this.initData.optionsScreen = true;
        this.disableEmailScreen.emit(false);
        this.initData.helpAndContactData.showEmailScreen = false;
        this.initData.helpAndContactData.showButtons = false;
        this.messageQueue.clear();
    }

    onEdit(editedValue: string) {
        this.data.message = this.data.message.trim();
        const fieldName = this.currentPage + '_' + editedValue;
        this.captureEventTracking(`Help_Contact_ContactOptions_Email_${this.loggedInTracking}${fieldName}_Edited`);

        if (editedValue == 'DateOfBirth') this.trackError('dateofbirth');

        if (editedValue == 'dateofincident') this.trackError(editedValue);
    }

    trackError(element: string) {
        if (this.isGreeceComplaintEnabled) {
            const errors = <Object>this.currentForm.controls[element].errors;
            const error = Object.keys(errors)[0] || null;
            element = element == 'messagebox' ? 'message' : element;
            const sitecoreMessages: { [key: string]: string } = this.initData.contactData.clientContentData.form[element.toLowerCase()]?.validation;
            const messagesLowerCase: { [key: string]: string } = Object.keys(sitecoreMessages).reduce(
                (c: { [key: string]: string }, k) => ((c[k.toLowerCase()] = sitecoreMessages[k]), c),
                {},
            );

            if (error)
                if (messagesLowerCase && messagesLowerCase[error.toLowerCase()])
                    this.tracking.triggerEvent('Event.Tracking', {
                        'component.CategoryEvent': 'Help Center',
                        'component.LabelEvent': 'Help options',
                        'component.ActionEvent': 'Load',
                        'component.PositionEvent': 'Official Complaint Form',
                        'component.LocationEvent': 'Error Message',
                        'component.EventDetails': messagesLowerCase[error.toLowerCase()],
                        'component.URLClicked': 'not applicable',
                    });
                else {
                    const errorMapping = this.validation.errorMapping[error];
                    if (messagesLowerCase[errorMapping])
                        this.tracking.triggerEvent('Event.Tracking', {
                            'component.CategoryEvent': 'Help Center',
                            'component.LabelEvent': 'Help options',
                            'component.ActionEvent': 'Load',
                            'component.PositionEvent': 'Official Complaint Form',
                            'component.LocationEvent': 'Error Message',
                            'component.EventDetails': messagesLowerCase[errorMapping.toLowerCase()],
                            'component.URLClicked': 'not applicable',
                        });
                }
        }
    }

    ngOnDestroy() {
        let footerElement = document.getElementsByTagName('vn-footer')[0];
        if (footerElement == null) {
            footerElement = document.getElementsByTagName('vn-responsive-footer')[0];
        }
        if (footerElement) {
            footerElement.setAttribute('style', 'display:block;');
        }
    }

    private handleSelectedDocChange(selectedDoc: DocumentSelected) {
        switch (selectedDoc.status) {
            case DocStatusType.docCleared:
                this.wait = false;
                break;
            case DocStatusType.docPicked:
                this.wait = true;
                this.tracking.triggerEvent('Event.HCC', {
                    'component.CategoryEvent': 'hcc',
                    'component.LabelEvent': 'complaint form',
                    'component.ActionEvent': 'click',
                    'component.LocationEvent': 'complaint form',
                    'component.EventDetails': 'id document upload',
                    'component.URLClicked': this.navigation.location.absUrl(),
                });
                break;
            case DocStatusType.docError:
                this.wait = false;
                this.tracking.triggerEvent('Event.HCC', {
                    'component.CategoryEvent': 'hcc',
                    'component.LabelEvent': 'complaint form',
                    'component.ActionEvent': 'failure',
                    'component.LocationEvent': 'complaint form',
                    'component.EventDetails': 'id document upload',
                    'component.URLClicked': this.navigation.location.absUrl(),
                });
                this.captureEventTracking('Help_Contact_ContactOptions_Email_DocUpload_DocNotSupported_Error');
                break;
            case DocStatusType.docSizeError:
                this.wait = false;
                this.tracking.triggerEvent('Event.HCC', {
                    'component.CategoryEvent': 'hcc',
                    'component.LabelEvent': 'complaint form',
                    'component.ActionEvent': 'error',
                    'component.PositionEvent': 'complaint form',
                    'component.LocationEvent': 'id document upload',
                    'component.EventDetails': this.initData.contactData.documentUploadContent.messages.NotSuccessfullyUploaded,
                    'component.URLClicked': this.navigation.location.absUrl(),
                });
                this.captureEventTracking('Help_Contact_ContactOptions_Email_DocUpload_MaxSizeExceeded_Error');
                break;
            case DocStatusType.docLoaded:
                this.wait = false;
                this.tracking.triggerEvent('Event.HCC', {
                    'component.CategoryEvent': 'hcc',
                    'component.LabelEvent': 'complaint form',
                    'component.ActionEvent': 'success',
                    'component.LocationEvent': 'complaint form',
                    'component.EventDetails': 'id document upload',
                    'component.URLClicked': this.navigation.location.absUrl(),
                });
                this.captureEventTracking('Help_Contact_ContactOptions_Email_DocUploaded');
                break;
        }
    }
    private handleSelectedSupportDocChange(selectedDoc: DocumentSelected) {
        switch (selectedDoc.status) {
            case DocStatusType.docCleared:
                this.wait = false;
                break;
            case DocStatusType.docPicked:
                this.wait = true;
                this.tracking.triggerEvent('Event.HCC', {
                    'component.CategoryEvent': 'hcc',
                    'component.LabelEvent': 'complaint form',
                    'component.ActionEvent': 'click',
                    'component.LocationEvent': 'complaint form',
                    'component.EventDetails': 'supporting document upload',
                    'component.URLClicked': this.navigation.location.absUrl(),
                });
                break;
            case DocStatusType.docError:
                this.wait = false;
                this.tracking.triggerEvent('Event.HCC', {
                    'component.CategoryEvent': 'hcc',
                    'component.LabelEvent': 'complaint form',
                    'component.ActionEvent': 'failure',
                    'component.LocationEvent': 'complaint form',
                    'component.EventDetails': 'supporting document upload',
                    'component.URLClicked': this.navigation.location.absUrl(),
                });
                break;
            case DocStatusType.docSizeError:
                this.wait = false;
                this.tracking.triggerEvent('Event.HCC', {
                    'component.CategoryEvent': 'hcc',
                    'component.LabelEvent': 'complaint form',
                    'component.ActionEvent': 'error',
                    'component.PositionEvent': 'complaint form',
                    'component.LocationEvent': 'supporting document upload',
                    'component.EventDetails': this.initData.contactData.complaintDocumentUpload.messages.NotSuccessfullyUploaded,
                    'component.URLClicked': this.navigation.location.absUrl(),
                });
                break;
            case DocStatusType.docLoaded:
                this.wait = false;
                this.tracking.triggerEvent('Event.HCC', {
                    'component.CategoryEvent': 'hcc',
                    'component.LabelEvent': 'complaint form',
                    'component.ActionEvent': 'success',
                    'component.LocationEvent': 'complaint form',
                    'component.EventDetails': 'supporting document upload',
                    'component.URLClicked': this.navigation.location.absUrl(),
                });
                break;
        }
    }
    private handleSelectedMultiDocChange(selectedDoc: DocumentSelected, documentType: any, documentFileType?: any) {
        switch (selectedDoc.status) {
            case DocStatusType.docCleared:
                this.wait = false;
                break;
            case DocStatusType.docPicked:
                this.wait = true;
                this.tracking.triggerEvent('Event.Tracking', {
                    'component.CategoryEvent': 'help center',
                    'component.LabelEvent': 'help options',
                    'component.ActionEvent': 'click',
                    'component.PositionEvent': 'official complaint form',
                    'component.LocationEvent': documentType,
                    'component.EventDetails': documentFileType,
                    'component.URLClicked': 'not applicable',
                });
                break;
            case DocStatusType.docError:
                this.wait = false;
                this.tracking.triggerEvent('Event.Tracking', {
                    'component.CategoryEvent': 'help center',
                    'component.LabelEvent': 'help options',
                    'component.ActionEvent': 'failure',
                    'component.PositionEvent': 'official complaint form',
                    'component.LocationEvent': documentType,
                    'component.EventDetails': documentFileType,
                    'component.URLClicked': 'not applicable',
                });
                break;
            case DocStatusType.docSizeError:
                this.wait = false;
                this.tracking.triggerEvent('Event.Tracking', {
                    'component.CategoryEvent': 'help center',
                    'component.LabelEvent': 'help options',
                    'component.ActionEvent': 'error',
                    'component.PositionEvent': 'official complaint form',
                    'component.LocationEvent': documentType,
                    'component.EventDetails': this.initData.contactData.documentUploadContent.messages.NotSuccessfullyUploaded,
                    'component.URLClicked': 'not applicable',
                });
                break;
            case DocStatusType.docLoaded:
                this.wait = false;
                this.tracking.triggerEvent('Event.Tracking', {
                    'component.CategoryEvent': 'help center',
                    'component.LabelEvent': 'help options',
                    'component.ActionEvent': 'success',
                    'component.PositionEvent': 'official complaint form',
                    'component.LocationEvent': documentType,
                    'component.EventDetails': documentFileType,
                    'component.URLClicked': 'not applicable',
                });
                break;
        }
    }
    private captureEventTracking(eventName: string) {
        this.tracking.triggerEvent('Event.Functionality.HelpContact', { 'page.referringAction': eventName });
    }

    private capturePageLoadTracking(eventName: string) {
        this.tracking.triggerEvent('pageView', { 'page.name': eventName });
    }
    private setFooter() {
        let footerElement = document.getElementsByTagName('vn-footer')[0];
        if (footerElement == null) {
            footerElement = document.getElementsByTagName('vn-responsive-footer')[0];
        }
        if (footerElement) {
            footerElement.setAttribute('style', 'display:none;');
        }
    }
    selectedOption(item: any) {
        if (item == 'ID') {
            const trackingEvents = {
                'component.CategoryEvent': 'help center',
                'component.LabelEvent': 'help options',
                'component.ActionEvent': 'click',
                'component.PositionEvent': 'official complaint form',
                'component.LocationEvent': 'not applicable',
                'component.EventDetails': 'Id doc',
                'component.URLClicked': 'not applicable',
            };
            this.tracking.triggerEvent('Event.Tracking', trackingEvents);
            this.enableBackIdUpload = true;
        } else {
            const trackingEvents = {
                'component.CategoryEvent': 'help center',
                'component.LabelEvent': 'help options',
                'component.ActionEvent': 'click',
                'component.PositionEvent': 'official complaint form',
                'component.LocationEvent': 'not applicable',
                'component.EventDetails': 'passport',
                'component.URLClicked': 'not applicable',
            };
            this.tracking.triggerEvent('Event.Tracking', trackingEvents);
            this.enableBackIdUpload = false;
        }
    }
    getDocErrors(hasError: boolean) {
        this.uploadedDocumentHasErrors = hasError ? true : false;
    }
    onBack = () => {
        this.isGreeceComplaintEnabled || this.navigation.location.search.has('type')
            ? this.gotoLastKnownProduct('Back')
            : this.gotoContactOptionScreen();
    };
}
